import { useState, useCallback } from "react";
import BaseReport from "../BaseReport/BaseReport";
import UserLastLoginTable from "../UserLastLoginTable/UserLastLoginTable";
import { RoleServiceProvider } from "../../services";
import ReportUserDetailsForm from "../ReportUserDetailsForm/ReportUserDetailsForm";
import "./UserLastLoginReport.css";
import "../BaseReport/BaseReport.css";
import { useTenant } from "../../contexts/TenantService";

const UserLastLoginReport = () => {
  const roleService = RoleServiceProvider();
  const { tenantSvc } = useTenant();
  const [callDataSvc, setCallDataSvc] = useState(false);
  const [formData, setFormData] = useState({});

  const getDataService = useCallback((roleService, formData) => {
    const { usernames, startDate, endDate } = formData;
    return roleService.getReportingDetails("user-last-login", usernames ?? "", startDate, endDate);
  }, []);
  const handleFormSubmit = (data) => {
    setFormData(data);
    setCallDataSvc(true);
  };

  return (
    <BaseReport
      title="User Last Login"
      getDataService={(roleService) => getDataService(roleService, formData)}
      tableComponent={UserLastLoginTable}
      formComponent={(props) => (
        <ReportUserDetailsForm
          {...props}
          onSubmit={handleFormSubmit}
          formData={formData}
          maxDays={tenantSvc?.reportEventsRetentionPeriodInDays}
        />
      )}
      roleService={roleService}
      callDataSvc={callDataSvc}
      transformData={false}
      setCallDataSvc={setCallDataSvc}
    />
  );
};

export default UserLastLoginReport;
